import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=5f5a116e&scoped=true&"
import script from "./CustomTable.vue?vue&type=script&lang=js&"
export * from "./CustomTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=5f5a116e&prod&lang=scss&scoped=true&"
import style1 from "./CustomTable.vue?vue&type=style&index=1&id=5f5a116e&prod&lang=css&"
import style2 from "./CustomTable.vue?vue&type=style&index=2&id=5f5a116e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5a116e",
  null
  
)

export default component.exports